<script lang="ts">
	import Posts from '$lib/components/posts.svelte';
	import PageHeader from '$lib/components/page-header.svelte';
	import { appName, blogBaseUrl } from '$lib/meta';
	import type { PageData } from './$types';

	export let data: PageData;
	export const { tag, posts } = data;
</script>

<svelte:head>
	<title>Posts tagged #{tag} | {appName}</title>
	<meta
		name="description"
		content={`All blog posts tagged #${tag} — practical software engineering guides by Dániel Sipos.`}
	/>

	{@html `<script type="application/ld+json">${JSON.stringify({
		'@context': 'https://schema.org',
		'@type': 'ItemList',
		itemListElement: posts.map((post, i) => ({
			'@type': 'ListItem',
			position: i + 1,
			url: `${blogBaseUrl}${post.path}`,
			name: post.metadata.title
		}))
	})}</script>`}
</svelte:head>

<section>
	<PageHeader>Tags / #{tag}</PageHeader>
	<Posts {posts} />
</section>
